var React = require('react');

function ImgPlaceholder (props) {
    return React.createElement("svg",props,React.createElement("switch",null,[React.createElement("foreignObject",{"requiredExtensions":"http://ns.adobe.com/AdobeIllustrator/10.0/","width":"1","height":"1","key":0}),React.createElement("path",{"d":"M-864.2 953.5h-69.6c-7 0-12.7 5.7-12.7 12.7v69.6c0 7 5.7 12.7 12.7 12.7h69.6c7 0 12.7-5.7 12.7-12.7v-69.6C-851.5 959.2-857.2 953.5-864.2 953.5zM-933.8 960.6h69.6c3.1 0 5.6 2.5 5.6 5.6v37.1l-16.1-20.3c-1.9-2.5-5.7-2.5-7.6 0l-23.5 29.7 -9.8-10.7c-2-2.2-5.5-2.2-7.5 0l-16.3 17.7v-53.5C-939.4 963.1-936.9 960.6-933.8 960.6z","key":1}),React.createElement("circle",{"cx":"-922","cy":"978","r":"8","key":2})]));
}

ImgPlaceholder.defaultProps = {"viewBox":"-949 951 100 100"};

module.exports = ImgPlaceholder;

ImgPlaceholder.default = ImgPlaceholder;
